"use client";

import Dropdown from "component/react-bootstrap/Dropdown";
import Menu from "component/react-bootstrap/DropdownMenu";
import Toggle from "component/react-bootstrap/DropdownToggle";
import MenuItem from "component/react-bootstrap/MenuItem";
import { RootState } from "interfaces/generics.type";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ExponentLabel } from "../../component/design-system/shared-styles/ExponentLabel";
import styles from "./headerCartIcon.module.scss";

const MultipleCartSummary = dynamic(() => import(/* webpackChunkName: "MultipleCartSummary" */"./multiple-cart-summary/MultipleCartSummary"));

function HeaderCartIcon(props) {
  const { children } = props;

  const [isOpen, setIsOpen] = useState(false);
  const multipleCartRef = useRef(null);
  const auth = useSelector((state: RootState) => state.authenticationState);
  const { businessCustomer } = auth;

  const shoppingCart = useSelector((state: RootState) => state.shoppingCart);
  const { numberOfItems } = shoppingCart;

  const isLoading = auth.refreshStatus !== "complete";

  function toggleHandler(_isOpen, e) {
    if (!multipleCartRef.current?.contains(e.target)) {
      setIsOpen(_isOpen);
    }
  }

  const componentToRender = (
    <>
      {children}
      <ExponentLabel style={{ top: "calc(0.3 * var(--safari-root-font, 10px))", right: "calc(-0.8 * var(--safari-root-font, 10px))", position: "absolute" }}>
        {!isLoading && numberOfItems}
      </ExponentLabel>
    </>
  );

  if (!businessCustomer) {
    return (
      (
        <Link href="/shopping-cart" prefetch={false} className={styles.anchor}>
          {componentToRender}
        </Link>
      )
    );
  }

  return (
    <Dropdown
      open={isOpen}
      toggleButtonClassName={`${styles.mobile_header_cart_icon} btn-sm btn-block`}
      onToggle={toggleHandler}
    >
      <Toggle
        aria-label="Garage Dropdown"
        className={` ${styles.btn} d-flex align-items-center justify-content-center`}
        noCaret
      >
        {componentToRender}
      </Toggle>
      <Menu className={styles.unordered_list}>

        {isOpen && (
          <div ref={multipleCartRef}>
            <MenuItem>
              <MultipleCartSummary />
            </MenuItem>
          </div>
        )}

      </Menu>
    </Dropdown>
  );
}

export default HeaderCartIcon;
